import * as ort from 'onnxruntime-web';

// Configure ONNX Runtime Web
// Don't set wasmPaths - let Vite handle it automatically through import resolution
ort.env.wasm.numThreads = 1; // Use single thread for better compatibility

export async function loadONNXModel(url) {
  console.log('🔄 Loading ONNX model from:', url);
  
  try {
    // Download model with explicit CORS mode
    const response = await fetch(url, {
      mode: 'cors',
      credentials: 'omit',
    });
    if (!response.ok) {
      throw new Error(`Failed to download model: ${response.status} ${response.statusText}`);
    }
    
    const arrayBuffer = await response.arrayBuffer();
    console.log('✅ Model downloaded, size:', (arrayBuffer.byteLength / 1024 / 1024).toFixed(2), 'MB');
    
    // Create session
    const session = await ort.InferenceSession.create(arrayBuffer, {
      executionProviders: ['wasm'], // Use WebAssembly backend
      graphOptimizationLevel: 'all',
    });
    
    console.log('✅ ONNX session created');
    console.log('  Input:', session.inputNames[0], session.inputNames);
    console.log('  Output:', session.outputNames[0], session.outputNames);
    
    return session;
  } catch (error) {
    console.error('❌ Failed to load ONNX model:', error);
    throw error;
  }
}

export async function runInference(session, inputTensor) {
  console.log('🤖 Running inference...');
  console.log('  Input shape:', inputTensor.dims);
  
  const startTime = performance.now();
  
  try {
    const feeds = {};
    feeds[session.inputNames[0]] = inputTensor;
    
    const results = await session.run(feeds);
    const output = results[session.outputNames[0]];
    
    const endTime = performance.now();
    console.log(`✅ Inference completed in ${(endTime - startTime).toFixed(0)}ms`);
    console.log('  Output shape:', output.dims);
    
    return output;
  } catch (error) {
    console.error('❌ Inference failed:', error);
    throw error;
  }
}

